import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import {
  updateDates,
  search,
  toggleExcludeMoyensAnnexes,
  updateParties,
  toggleAggregation,
  updateLawyerFilter,
  updateEnterpriseFilter,
  updateLawOfficeFilter,
  removeRestrictionToLawArticleId,
} from '../../../../state/actions';
import { StateType } from '../../../../../state/state.types';
import {
  buildDateFilter,
  buildAggregationFilters,
  buildPartiesFilter,
  buildLegislationFilter,
} from './filterBoxUtils';

const mapState = (state: StateType) => {
  const {
    dates,
    excludeMoyensAnnexes,
    parties,
    restrictToLawArticleIds,
    lid,
    eid,
    oid,
    aggregationsPaths,
  } = state.queryParams;
  const {
    restriction,
    snippets: { law },
  } = state.results;
  const { aggregations } = state;
  return {
    enterprise:
      eid && restriction && restriction.enterprise
        ? restriction.enterprise
        : null,
    lawyer:
      lid && restriction && restriction.lawyer ? restriction.lawyer : null,
    lawOffice:
      oid && restriction && restriction.lawOffice
        ? restriction.lawOffice
        : null,
    legislation:
      restrictToLawArticleIds?.length && law
        ? law.otherVersions
            .filter(article =>
              restrictToLawArticleIds.includes(article.articleId),
            )
            .map(article => {
              return {
                articleId: article.articleId,
                text: buildLegislationFilter(article),
              };
            })
        : null,
    date: dates ? buildDateFilter(dates) : null,
    excludeMoyensAnnexes,
    aggregations: [
      ...buildAggregationFilters(aggregationsPaths, 'ville', aggregations),
      ...buildAggregationFilters(
        aggregationsPaths,
        'juridiction',
        aggregations,
      ),
      ...buildAggregationFilters(aggregationsPaths, 'domaine', aggregations),
      ...buildAggregationFilters(aggregationsPaths, 'publi', aggregations),
      ...buildAggregationFilters(aggregationsPaths, 'solution', aggregations),
      ...buildAggregationFilters(aggregationsPaths, 'publisher', aggregations),
      ...buildAggregationFilters(
        aggregationsPaths,
        'commentaryAccess',
        aggregations,
      ),
      ...buildAggregationFilters(aggregationsPaths, 'textCode', aggregations),
      ...buildAggregationFilters(
        aggregationsPaths,
        'otherLegislation',
        aggregations,
      ),
      ...buildAggregationFilters(
        aggregationsPaths,
        'collectiveAgreements',
        aggregations,
      ),
    ],
    parties: parties ? buildPartiesFilter(parties) : null,
  };
};

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  removeDateFilter() {
    dispatch(updateDates({}));
    dispatch(search({ reason: 'faceted' }));
  },
  removeMoyensAnnexesFilter() {
    dispatch(toggleExcludeMoyensAnnexes());
    dispatch(search({ reason: 'exclude' }));
  },
  removePartiesFilter() {
    dispatch(updateParties({}));
    dispatch(search({ reason: 'faceted' }));
  },
  removeLegislationFilter(articleId: string) {
    dispatch(removeRestrictionToLawArticleId(articleId));
    dispatch(search({ reason: 'restrict-from-snippet' }));
  },
  removeAggregationFilter(path: Array<string>) {
    dispatch(toggleAggregation(path, false));
    dispatch(search({ reason: 'faceted' }));
  },
  removeLawyerFilter() {
    dispatch(updateLawyerFilter(undefined));
    dispatch(search({ reason: 'lawyerFilter' }));
  },
  removeLawOfficeFilter() {
    dispatch(updateLawOfficeFilter(undefined));
    dispatch(search({ reason: 'lawOfficeFilter' }));
  },
  removeEnterpriseFilter() {
    dispatch(updateEnterpriseFilter(undefined));
    dispatch(search({ reason: 'enterpriseFilter' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
